import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";
import { Check, ArrowUpRight, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Reveal from "@/components/Reveal";

const CITIZEN = ["Pickup from your doorstep at a time you choose", "See indicative scrap rates before you book", "Material weighed in front of you", "Your dry waste goes to recycling, not a landfill"];
const PARTNER = ["Receive pickup requests from homes & shops nearby", "Plan your route and day on your phone", "Build a trusted profile with your customers", "Simple sign-up on your phone"];

function Side({ tone, eyebrow, title, points, cta, href, testid, image }) {
  const dark = tone === "dark";
  return (
    <div className={`rounded-[32px] overflow-hidden card-lift border ${dark ? "bg-[var(--ink)] text-white border-transparent grain" : "bg-white border-[rgba(20,40,26,.08)]"}`} data-testid={testid}>
      <img src={image} alt="" className="w-full h-56 sm:h-64 object-cover" />
      <div className="p-7 sm:p-9">
        <div className={`text-xs font-bold tracking-[0.2em] uppercase ${dark ? "text-[var(--marigold)]" : "text-[var(--leaf)]"}`}>{t(eyebrow)}</div>
        <h3 className="mt-3 text-2xl sm:text-3xl font-bold leading-tight">{t(title)}</h3>
        <ul className="mt-6 space-y-3">
          {points.map((p) => (
            <li key={t(p)} className={`flex gap-3 text-sm sm:text-base ${dark ? "text-[#D9D3C3]" : "text-[var(--ink-soft)]"}`}>
              <span className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${dark ? "bg-[var(--marigold)] text-[var(--ink)]" : "bg-[var(--leaf-soft)] text-[var(--leaf-dark)]"}`}><Check size={12} strokeWidth={3} /></span>
              {t(p)}
            </li>
          ))}
        </ul>
        <a href={href} className={`${dark ? "btn-marigold" : "btn-leaf"} mt-8 text-sm`} data-testid={`${testid}-cta`}>{t(cta)} <ArrowUpRight size={16} /></a>
      </div>
    </div>
  );
}

export default function TwoSides() {
  const { content: c } = useSite();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="two-sides-section">
      <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="max-w-2xl">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("One platform, two neighbours")}</div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">{t("Made for the people who give, and the people who collect.")}</h2>
        </div>
        <Link to="/kabadiwalas" className="inline-flex items-center gap-2 font-semibold text-[var(--leaf-dark)] link-u" data-testid="two-sides-partner-link">{t("Partner details")} <ArrowRight size={16} /></Link>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <Reveal><Side tone="light" eyebrow="For homes, shops & offices" title={t("Clear out your scrap, the easy way.")} points={CITIZEN} cta={c.consumer_cta_label} href={c.consumer_app_url} testid="citizen-card" image={c.image_home} /></Reveal>
        <Reveal delay={120}><Side tone="dark" eyebrow="For kabadiwalas" title={t("More pickups, closer to you.")} points={PARTNER} cta="Join as a partner" href={c.partner_app_url} testid="partner-card" image={c.image_kabadiwala} /></Reveal>
      </div>
    </section>
  );
}
